import React from "react";
import "./search.css";
import { Btn } from "../../utils/utils";
import { Location, SearchNormal1 } from "iconsax-react";
import useFilterData from "../../hooks/useFilterData";

const SearchFilter = ({btnClick, loading}) => {
  const {filterMenu} = useFilterData();

  const {data, setData} = useFilterData();
  const {setPropType} = useFilterData();
  const {setPropUse} = useFilterData();

  const {activeProp, setActiveProp} = useFilterData();

  const handleDataChange = (e) => {
    const newData = { ...data };
    newData[e.target.id] = e.target.value;
    setData(newData);
  }
  

  const filterChoice = [
    {
      name: "Location",

      input: (
        <div className="filt_inp">
          <input placeholder="Enter location" id="location" value={data?.location} onChange={(e) => handleDataChange(e)} />
          <Location size="16" color="#FF8A65"/>
        </div>
      ),
    },
    {
      name: "Property Type",
      input: (
        <div className="filt_inp">
          <select placeholder="Choose property type" onChange={(e) => setPropType(e.target.value)}>
            <option value="All" id="All">All</option>
            <option value="Sell" id="Sell" >Sell</option>
            <option value="Rent" id="Rent" >Rent</option>
          </select>
        </div>
      ),
    },
    {
      name: "Property Use",
      input: (
        <div className="filt_inp">
          <select placeholder="Choose property type" onChange={(e) => setPropUse(e.target.value)}>
            <option value="All" id="All">All</option>
            <option value="Residential" id="Residential" >Residential</option>
            <option value="Commercial" id="Commercial" >Commercial</option>
          </select>
        </div>
      ),
    },
    {
      name: "Bedrooms",
      input: (
        <div className="filt_inp">
          <input type="Number" placeholder="Enter number of bedrooms" id="bedrooms" value={data?.bedrooms} onChange={(e) => handleDataChange(e)} />
        </div>
      ),
    },
    {
      name: "Min.price",
      input: (
        <div className="filt_inp">
          <input type="Number" placeholder="Enter minimum price" id="minPrice" value={data?.minPrice} onChange={(e) => handleDataChange(e)} />
        </div>
      ),
    },
    {
      name: "Max.price",
      input: (
        <div className="filt_inp">
          <input type="Number" placeholder="Enter maximum price" id="maxPrice" value={data?.maxPrice} onChange={(e) => handleDataChange(e)} />
        </div>
      ),
    },
  ];

  const clickMenu = (item) => {
    setActiveProp(item);
  };

  return (
    <div className="search-filter">
      <div className="search-head">
        {filterMenu && filterMenu?.map((item, idx) => {
          return (
            <div key={idx} className="each-menu">
              <p
                className={activeProp === item ? `active-menu` : ""}
                onClick={() => clickMenu(item)}
              >
                {item}
              </p>
            </div>
          );
        })}
      </div>
      <div className="search-body">
        {filterChoice?.map((item, i) => {
          return (
            <div key={i} className="each-choice">
              <p>{item.name}</p>
              {item.input}
            </div>
          );
        })}
        <Btn
          btnClass={"home-btn"}
          btnText={"Search"}
          btnClick={btnClick}
          leftIcon={<SearchNormal1 />}
          btnWidth={"100%"}
          loading={loading}
        />
      </div>
    </div>
  );
};

export default SearchFilter;
